/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
    mdiForum,
    // mdiAccountBadge,
    mdiViewList,
    mdiAccountCheckOutline,
    mdiInformationOutline
  } from '@mdi/js'

  export default [
    'General',
    [
      {
        label: 'Comboard',
        to: '/home-comboard',
        icon: mdiForum
      }
    ],
    'Examples',
    [
        {
            label: 'Comboard List',
            to: '/comboardlist',
            icon: mdiViewList
        },
        {
        to: '/comboarduser',
          label: 'Comboard User',
          icon: mdiAccountCheckOutline
        },
        {
            to: '/comboardcategory',
            label: 'Comboard Category',
            icon: mdiInformationOutline
        }
        // {
        //   to: '/comboardrecipients',
        //     label: 'Comboard Recipients',
        //     icon: mdiAccountBadge
        //   }
  ]
]
